export const NEXUS_CONNECTED_APP_BLOCKS = [
  {
    type: 'appConnection',
    title: 'Salesforce',
    description: 'CRM connected. Lead sync, RFQ objects, and workflow triggers are active.',
    iconUrl: 'https://cdn.simpleicons.org/salesforce/00A1E0',
    status: 'connected',
    toolkitSlug: 'salesforce',
    tags: ['OAuth2', 'REST API'],
  },
  {
    type: 'appConnection',
    title: 'HubSpot',
    description: 'SRM connected. Supplier relationship records and pipeline sync enabled.',
    iconUrl: 'https://cdn.simpleicons.org/hubspot/FF7A59',
    status: 'connected',
    toolkitSlug: 'hubspot',
    tags: ['OAuth2', 'Webhooks'],
  },
  {
    type: 'appConnection',
    title: 'Procurify',
    description: 'Procurement management connected. Purchase requests and approvals wired to the RFQ flow.',
    iconUrl: 'https://cdn.simpleicons.org/procurify/5C6BC0',
    status: 'connected',
    toolkitSlug: 'procurify',
    tags: ['OAuth2', 'Purchase Orders'],
  },
  {
    type: 'appConnection',
    title: 'Stripe',
    description: 'Application is already connected. Payment webhooks are listening.',
    iconUrl: 'https://cdn.simpleicons.org/stripe/635BFF',
    status: 'connected',
    toolkitSlug: 'stripe',
    tags: ['API Key', 'Webhooks'],
  },
  {
    type: 'appConnection',
    title: 'Mailchimp',
    description: 'Application is already connected. RFQ nurture journey is mapped.',
    iconUrl: 'https://cdn.simpleicons.org/mailchimp/FFE01B',
    status: 'connected',
    toolkitSlug: 'mailchimp',
    tags: ['OAuth2', 'Audiences'],
  },
]
